import React from 'react'

import { FieldPrefix } from '../../../../../1stlog-ui/src/components/Field'
import AddressPickerAdvanced from '../../../AddressPickerAdvanced'
import AddressPickerAdvancedReadonly from '../../../AddressPickerAdvanced/Readonly'
import OrderEntryCard, {
  IOrderEntryCardProps,
} from '../../components/OrderEntryCard'
import useOrderEntry from '../../useOrderEntry'
import { getAddressPickerLabels } from '../../utils/getAddressPickerLabels'

interface TCustomerAddressProps
  extends Omit<IOrderEntryCardProps, 'title' | 'children'> {
  readonly?: boolean
}

const CustomerAddress = (props: TCustomerAddressProps): React.ReactElement => {
  const { readonly, ...rest } = props

  const { currentCustomer } = useOrderEntry()

  if (currentCustomer) {
    return <></>
  }

  return (
    <OrderEntryCard
      {...rest}
      title={i18n.t('title_customer_address', 'Kundenadresse')}
    >
      <FieldPrefix prefix="address">
        {readonly ? (
          <AddressPickerAdvancedReadonly />
        ) : (
          <AddressPickerAdvanced labels={getAddressPickerLabels()} />
        )}
      </FieldPrefix>
    </OrderEntryCard>
  )
}

export default CustomerAddress
